module.exports = function (propertyData, maxWidth, maxHeight, format, bgcolor, quality = 80, useTranspancy = false) {
    var imageData = (typeof propertyData === "string" && propertyData[0] === '{') ? JSON.parse(propertyData) : propertyData;

    let url = "";
    let isPng = ((imageData.src || imageData).indexOf(".png") > 0 || (imageData.src || imageData).indexOf(".tif") > 0 ) && useTranspancy;

    if (imageData.src) {
        url = imageData.src +
            (imageData.src.indexOf("?") > 0 ? "&" : "?") +
            "mode=pad";
    } else {
        url = imageData +
            (imageData.indexOf("?") > 0 ? "&" : "?") +
            "mode=pad";
    }
        
    if (maxWidth) {
        //url += "&width=" + parseInt(maxWidth);
        url += "&width=" +maxWidth;
    }

    if (maxHeight) {
        //url += "&height=" + parseInt(maxHeight);
        url += "&height=" + maxHeight;
    }

    if (format && !isPng) {
        url += "&format=" + format;
        //todo: Add PostProcessing to remove meta-data
    }

    if (bgcolor && !isPng) {
        url += "&bgcolor=" + bgcolor;
    }

    if (quality) {
        url += "&quality=" + quality;
    }

    url += "&sharpen=true";
    
    const result = { url: url, width: maxWidth, height: maxHeight };
    return result;
};